export default "__VITE_ASSET__BJsh$8Gk__"